import type * as React from 'react';
import { cn } from '../../lib/cn.ts';
import { Input } from '../input.tsx';

export interface ListToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  /** Filter controls (Selects, date inputs) rendered next to the search box. */
  children?: React.ReactNode;
  /** Optional trailing action (e.g. a Clear-filters button), pushed to the right. */
  trailing?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

/**
 * ListToolbar — a calm filter bar: a search input plus a slot for filter
 * controls and an optional trailing action. Presentational; the page owns the
 * state (typically URL search params) and any debouncing.
 */
export function ListToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  children,
  trailing,
  className,
  'data-testid': testId,
}: ListToolbarProps) {
  return (
    <div data-testid={testId} className={cn('flex flex-wrap items-center gap-2 pb-4', className)}>
      <Input
        data-testid={testId ? `${testId}-search` : undefined}
        type="search"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={searchPlaceholder}
        className="h-8 w-56"
      />
      {children}
      {trailing && <div className="ml-auto">{trailing}</div>}
    </div>
  );
}
